import { configurationsApi } from "@shared/api"
import { formatCountries } from "@shared/lib/mapper"
import { FormattedCountry } from "@shared/models"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type State = {
	countries: FormattedCountry[]
}

type Actions = {
	fetchCountries: () => Promise<void>
	resetStore: () => void
}

const initialState: State = {
	countries: [],
}

export const useCountriesStore = create<State & Actions>()(
	immer(set => ({
		...initialState,

		fetchCountries: async () => {
			const countries = await configurationsApi.getCounties()
			const formattedCountries = formatCountries(countries)

			set(state => {
				state.countries = formattedCountries
			})
		},

		resetStore: () => set(initialState),
	})),
)
